// @flow
export const CELLPHONE_SMALL_WIDTH: number = 320;
export const CELLPHONE_WIDTH: number = 536.5;
export const TABLET_SMALL_WIDTH: number = 767.5;
export const TABLET_WIDTH: number = 991.5;
export const COMPUTER_SMALL_WIDTH: number = 1199.5;

// Margen de gracia para los redondeos.
// Con esta diferencia entre el limite de la orden de compra y los montos de las facturas,
// se determina cunado una orden es completa y hasta que valor se aceptan facturas.
export const MARGIN_TO_ASSOCIATE_INVOICES = 10;

// Margen de gracia para los redondeos para ordenes de Mano de Obra.
// Con esta diferencia entre el limite de la orden de compra y los montos de las facturas,
// se determina cunado una orden es completa y hasta que valor se aceptan facturas.
export const MARGIN_TO_ASSOCIATE_INVOICES_TO_MO_ORDER = 100;

export const TIPO_DOC = {
  CI: 1,
  RUT: 2,
  ASSURED: 0
};

export const purchaseOrderStates = {
  PENDING: 'PENDING',
  ORDER_DELETED: 'ORDER_DELETED',
  INVOICES_ADDED: 'INVOICES_ADDED',
  PAYMENT_PENDING: 'PAYMENT_PENDING',
  PAYMENT_PARCIAL: 'PAYMENT_PARCIAL',
  COMPLETE_IN_PROGRESS: 'COMPLETE_IN_PROGRESS',
  COMPLETE_PROCESSED: 'COMPLETE_PROCESSED',
  CANCELLED: 'CANCELLED',
  CANCELLED_PROCESSED: 'CANCELLED_PROCESSED'
};
export const paymentStates = {
  REQUESTED: 'REQUESTED',
  REJECTED: 'REJECTED',
  IN_PROGRESS: 'IN_PROGRESS',
  PROCESSED: 'PROCESSED',
  UNASSOCIATED_INVOICES: 'UNASSOCIATED_INVOICES',
  ALL_INVOICES: 'ALL_INVOICES'
};

// TODO: Revisar que la moneda viene de dos maneras distintas y unificar
// COD_COIN[0] => 'UYU'
// COD_COIN[1] => 'USD'
export const COD_COIN = ['UYU', 'USD'];

// A partir de una cantidad de dias menor estricto a MAX_DUE_DATE_WARNING
// se muestran las advertencias (Badges) de vencimiento de pago
export const MAX_DUE_DATE_WARNING = 8;

// Limite de seguridad al validar el usuario contra la libreria de Google recaptcha V3
export const SECURITY_LIMIT = 0.5;

// SURA te lleva
export const DRIVER_REQUEST_DUES = [1, 2, 3, 4, 5, 6, 8, 10, 12];

// Datos de Sistarbanc
export const URL_SISTARBANC =
  'https://spf.sistarbanc.com.uy/spfdebitos/seleccionFactura.jsp?entidad=RSA&servicio=SEG&banco=';
export const ID_BROU = '001';
export const ID_BBVA = '153';
export const ID_SANTANDER = '137';
export const ID_HERITAGE = '216';

// Datos de Paganza
export const URL_PAGANZA = 'https://www.paganza.com/';
export const PAGANZA_ANDROID = 'https://play.google.com/store/apps/details?id=paganza.android&hl=es_419';
export const PAGANZA_IPHONE = 'itms-apps://apps.apple.com/us/app/paganza/id566320731'; // "https://apps.apple.com/us/app/paganza/id566320731";

// Limite de días para mostrar notificaciones
export const NOTIFICATION_DAYS = 7;
